export default "__VITE_ASSET__c92722f0__"